module.exports = __webpack_public_path__ + "static/media/abhinav.d9ae70f1.jpg";